import { FormSuccess } from '../../../components/FormSuccess'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'

export default function ConexaoMagentaCompletePage() {
  return (
    <PublicFormLayout title="Conexão Magenta">
      <FormSuccess
        title="Conexão Magenta Concluído!"
        description="Obrigado por participar do Conexão Magenta!"
        actions={[
          { label: 'Retornar para página inicial', to: '/conexao-magenta', loggedOnly: true },
          { label: 'Realizar um novo Conexão Magenta', to: '/conexao-magenta/new' }
        ]}
      />
    </PublicFormLayout>
  )
}
